import { FC } from 'react'

const TagStatisticSkeleton: FC = () => (
  <div className={'bg-skeleton-primary w-full animate-pulse rounded-md text-transparent'}>.</div>
)

export default TagStatisticSkeleton
